import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { basicInitialState } from "@src/Actions/ReducerUtils"
import { Locale } from "@src/Enums/Locale"
// Import the type but not the actual value from Model
import type { tBrandState } from "@src/Model/Model"

export const initialBrandState: tBrandState = {
  ...basicInitialState,
  brandId: "",
  brandLogo:
    "https://images.zeguro.com/Brand+Logos/logo_cyber_safety_brand_agnostic_hor.svg",
  brandNameLong: "Cyber Safety",
  brandNameShort: "Cyber Safety",
  webDomain: "",
  conciergeEmail: "",
  conciergeSchedulingLink: "",
  helpCenter: "",
  emailDomain: "cybersafety-mail.com",
  marketingCollateral: "",
  webDomainPerLocaleMap: {
    [Locale.EN_US]: "",
    [Locale.EN_CA]: "",
    [Locale.FR_CA]: "",
  },
}

const brandSlice = createSlice({
  name: "brand",
  initialState: initialBrandState,
  reducers: {
    getBrandRequest(state) {
      state.isLoading = true
    },
    getBrandSuccess(state, { payload }: PayloadAction<Partial<tBrandState>>) {
      return { ...initialBrandState, ...payload, isLoading: false }
    },
    getBrandFailure(state, { payload }: PayloadAction<any>) {
      return { ...initialBrandState, error: payload, isLoading: false }
    },
  },
})

export const { name, actions, reducer } = brandSlice
